export default "__VITE_ASSET__Bi4wiPuK__"